import * as React from 'react';
import { InputChangeType } from '../../types';
import './ContractComparisonChangeLabel.less';

const changeTypeLabels: Record<InputChangeType, string> = {
    added: 'Added',
    removed: 'Removed',
    modified: 'Modified',
    unsaved: 'Unsaved Changes'
} as const;

interface Props {
    changeType: InputChangeType;
}

const ContractComparisonChangeLabel: React.FC<Props> = ({ changeType }) => (
    <div className="change-type-container">
        <span className={`change-type-label ${changeType}`}>{changeTypeLabels[changeType]}</span>
    </div>
);

export default ContractComparisonChangeLabel;
